import { createContext, useContext } from "react";
import { PluginContextType } from "./types";

//MeshPlugin Context
export const PluginContext = createContext<PluginContextType | undefined>(
  undefined,
);

// Custom hook to use MeshPlugin context
// Must be used within MeshPluginProvider

export const useMeshPluginContext = (): PluginContextType => {
  const context = useContext(PluginContext);
  if (!context) {
    throw new Error(
      "useMeshPluginContext must be used within MeshPluginProvider",
    );
  }
  return context;
};
